import type { JSX, ReactNode, TableHTMLAttributes, ThHTMLAttributes, TdHTMLAttributes } from 'react'

export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  children: ReactNode
}

export function Table({ className = '', children, ...props }: TableProps): JSX.Element {
  return (
    <div className="fui-table-container">
      <table className={`fui-table ${className}`} {...props}>
        {children}
      </table>
    </div>
  )
}

export interface TableHeadProps {
  children: ReactNode
}

export function TableHead({ children }: TableHeadProps): JSX.Element {
  return <thead>{children}</thead>
}

export interface TableBodyProps {
  children: ReactNode
}

export function TableBody({ children }: TableBodyProps): JSX.Element {
  return <tbody>{children}</tbody>
}

export interface TableRowProps {
  children: ReactNode
  onClick?: () => void
}

export function TableRow({ children, onClick }: TableRowProps): JSX.Element {
  return (
    <tr onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
      {children}
    </tr>
  )
}

export interface TableHeaderProps extends ThHTMLAttributes<HTMLTableCellElement> {
  children: ReactNode
}

export function TableHeader({ className = '', children, ...props }: TableHeaderProps): JSX.Element {
  return (
    <th className={className} {...props}>
      {children}
    </th>
  )
}

export interface TableCellProps extends TdHTMLAttributes<HTMLTableCellElement> {
  children: ReactNode
}

export function TableCell({ className = '', children, ...props }: TableCellProps): JSX.Element {
  return (
    <td className={className} {...props}>
      {children}
    </td>
  )
}
